import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "om_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
};
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// SEC-005 : jeton de téléchargement signé à durée limitée (portée « download »),
// utilisé dans les URLs de PDF/fichiers à la place du jeton d'accès complet.
let _dlToken = "";
let _dlTimer = null;
export const getDlToken = () => _dlToken;
export const refreshDownloadToken = async () => {
  try {
    const { data } = await api.get("/auth/download-token");
    _dlToken = data.token || "";
    if (_dlTimer) clearTimeout(_dlTimer);
    const next = Math.max(60, (data.expires_in || 7200) - 120) * 1000;
    _dlTimer = setTimeout(refreshDownloadToken, next);
  } catch (e) {
    /* repli : le cookie httpOnly authentifie aussi les téléchargements same-origin */
  }
  return _dlToken;
};

// Build a displayable URL for a stored photo path (or pass through absolute URLs).
export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("blob:") || path.startsWith("data:")) return path;
  return _dlToken ? `${API}/files/${path}?t=${_dlToken}` : `${API}/files/${path}`;
};

// Ajoute le jeton de téléchargement à une URL de PDF/fichier (repli cookie si absent).
export const withDlToken = (url) => {
  if (!_dlToken) return url;
  return url + (url.includes("?") ? "&" : "?") + "t=" + _dlToken;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Renouvellement silencieux de session (cookie httpOnly refresh_token) partagé entre requêtes concurrentes.
let _refreshing = null;
const refreshSession = () => {
  if (!_refreshing) {
    _refreshing = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .then((r) => { setToken(r.data.access_token); return r.data.access_token; })
      .finally(() => { setTimeout(() => { _refreshing = null; }, 3000); });
  }
  return _refreshing;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const cfg = error.config || {};
    const url = cfg.url || "";
    const isAuthCheck = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (status === 401 && !isAuthCheck && !cfg._retried) {
      try {
        const tok = await refreshSession();
        cfg._retried = true;
        cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${tok}` };
        return api(cfg);
      } catch { /* session réellement expirée : retour à la connexion */ }
    }
    if (status === 401 && !isAuthCheck && !url.includes("/auth/me")) {
      clearToken();
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    if (status === 402 && !window.location.pathname.startsWith("/abonnement")) {
      window.location.assign("/abonnement");
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
